<template>
    <div>
        <h1 v-if="!pokemon">Generando pokemon! Espere.</h1>
        <div v-else>
            <h1 v-if="!disabled">¡ Averigua el siguiente pokemon <i class='bx bx-search-alt' style='color:#ffffff'  ></i> !</h1>
            <div v-else class="relleno"></div>
            <PokemonPicture data-test-id="pokemonPictureComponent" :pokemonId="pokemon.id" :showPokemon="showPokemon"/>
            <PokemonOptions  data-test-id="pokemonOptionsComponent" :pokemons="pokemonArr" @selection="checkAnswer" :disabled="disabled"/>
            <div>
                <h2 v-if="showAnswer">{{ message }}</h2>
                
                <h3 v-if="fails<4" class="container-info"><i class='bx bxs-badge-check' style='color:#f5f2f2' ></i>  {{ hits }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i v-if="fails<=3" class='bx bxs-heart' style='color:#f7f6f6'  ></i><i v-if="fails<=2" class='bx bxs-heart' style='color:#f7f6f6'  ></i><i v-if="fails<=1" class='bx bxs-heart' style='color:#f7f6f6'  ></i><i v-if="fails<=0" class='bx bxs-heart' style='color:#f7f6f6'  ></i></h3>
                <h1 v-if="hits>=20&&fails<4">¡Has ganado, enhorabuena!</h1>
                <h1 class="fail-final-message" v-if="hits<20&&fails>=4">¡Has perdido, a la próxima será, campeón!</h1>
                <button v-if="(fails<4&&hits<20)&&answerCheck" @click="nextRound">Siguiente</button>
                <button v-if="fails>=4||hits>=20" @click="newGame">Nueva partida</button>

            </div>
        </div>
    </div>
</template>

<script>
import PokemonOptions from '@/components/PokemonOptions.vue'
import PokemonPicture from '@/components/PokemonPicture.vue'
import getPokemonOptions from '@/helpers/getPokemonOptions'

export default {
    components: {
        PokemonOptions,
        PokemonPicture
    },
    data(){
        return{
            pokemonArr: [],
            pokemon: null,
            showPokemon: false,
            showAnswer: false,
            message: '',
            hits: 0,
            fails: 0,
            disabled: false,
            answerCheck: false,
        }
    },
    methods: {
        async mixPokemonArray(){
            this.pokemonArr = await getPokemonOptions()
            
            const rndInt = Math.floor(Math.random() * 4)
            this.pokemon = this.pokemonArr[rndInt]
        },
        checkAnswer(selectedId){

            this.showPokemon = true

            if(selectedId === this.pokemon.id){
                this.message = `Correcto, ${this.pokemon.name}`
                this.showAnswer = true
                this.disabled = true
                this.answerCheck = true
                this.hits++
            }else{
                this.message = `Oops, era ${this.pokemon.name}`
                this.showAnswer = true
                this.disabled = true
                this.answerCheck =  true
                this.fails++
            }

        },
        nextRound(){
            if(!this.answerCheck){
                this.fails++
            }

            this.start = true
            this.answerCheck = false
            this.showPokemon = false
            this.showAnswer = false
            this.disabled = false
            this.mixPokemonArray()
        },
        newGame(){
            this.pokemonArr = []
            this.message = ''
            this.pokemon= null
            this.showPokemon = false
            this.showAnswer = false
            this.hits = 0
            this.fails = 0
            this.disabled = false
            this.mixPokemonArray()
        },
    },
    mounted(){ //Este método se ejecuta solo una vez, como un onInit
        this.mixPokemonArray()
    }
}
</script>

<style scoped>

    h1{
        margin-top: 60px;
        color: white;
        filter: drop-shadow(3px 3px 3px red);
    }

    button{
        padding: 10px;
        width: 150px;
        border-radius: 10px 10px;
        text-transform: uppercase;
        background-color: #222;
        color: white;
    }

    button:hover{
        background-color: crimson;
    }

    h2, h3{
        color: white;
        filter: drop-shadow(3px 3px 3px black);
    }

    .bx-right-arrow-alt{
        vertical-align: middle;
    }

    .fail-final-message{
        color: red;
    }

    .bxs-badge-check{
        vertical-align: middle;
        font-size: 25px;
    }

    .bxs-heart{
        color: crimson !important;
        font-size: 25px;
        vertical-align: middle;
        filter: drop-shadow(1px 1px 1px #fff);
    }

    .container-pre-start{
        height: 70vh;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
    }

    .bx-search-alt{
        vertical-align: middle;
    }

    .relleno{
        height: 80px;
    }

    .container-info{
        padding: 4px;
    }

    @media (max-width: 600px){

        h1{
            margin-top: 15px;
        }

        h3{
            margin-top: 0;
        }

        .fail-final-message{
            font-size: 20px;
            font-style: italic;
            margin-top: 0px;
        }
    }

</style>